module.exports = __webpack_public_path__ + "img/under_development.425b3567.png";